import register from './labels/register';
import login from './labels/login';
import general from './labels/general';
import footer from './labels/footer';
import sideMenu from './labels/sideMenu';
import users from './labels/users';
import companies from './labels/companies';
import country from './labels/country';
import roles from './labels/roles';
import cities from './labels/cities';
import states from './labels/states';
import threats from './labels/threats';
import assets from './labels/assets';
import probabilityMeasureTypes from './labels/probabilityMeasureTypes';
import vulnerabilities from './labels/vulnerabilities';
import impacts from './labels/impacts';
import parameters from './labels/parameters';
import risks from './labels/risks';
import scopes from './labels/scopes';
import controls from './labels/controls';
import treatmentPlan from './labels/treatmentPlan';
import accountSettings from './labels/accountSettings';
import plans from './labels/plans';
import addons from './labels/addons';
import subscriptions from './labels/subscriptions';
import hardcaps from './labels/hardcaps';
import quota from './labels/quota';
import mySubscription from './labels/mySubscription';
import dashboard from './labels/dashboard';

export default {
    ...register,
    ...login,
    ...general,
    ...footer,
    ...sideMenu,
    ...users,
    ...roles,
    ...companies,
    ...country,
    ...cities,
    ...states,
    ...threats,
    ...assets,
    ...probabilityMeasureTypes,
    ...impacts,
    ...vulnerabilities,
    ...parameters,
    ...risks,
    ...scopes,
    ...controls,
    ...treatmentPlan,
    ...accountSettings,
    ...plans,
    ...addons,
    ...subscriptions,
    ...hardcaps,
    ...quota,
    ...mySubscription,
    ...dashboard,
};